import React, { useContext } from 'react';
import {
  MOB_CAB_ONE_WAY_CLICK,
  MOB_CAB_ROUND_TRIP_CLICK,
  MOB_CABS_AT_LANDING_TO_AIRPORT_RADIO_BUTTON,
  MOB_CABS_FROM_LANDING_TO_AIRPORT_RADIO_BUTTON
} from '../../../../src/constants/omnitureConstants';
import { CabsLandingContext } from '../../../CabsLandingContext';

const setOmniture = (title, trackTemplateEvent) => {
  switch (title) {
    case 'One Way':
      trackTemplateEvent(MOB_CAB_ONE_WAY_CLICK);
      break;
    case 'Round Trip':
      trackTemplateEvent(MOB_CAB_ROUND_TRIP_CLICK);
      break;

    case 'Travel To Airport':
      trackTemplateEvent(MOB_CABS_AT_LANDING_TO_AIRPORT_RADIO_BUTTON);
      break;

    case 'Travel From Airport':
      trackTemplateEvent(MOB_CABS_FROM_LANDING_TO_AIRPORT_RADIO_BUTTON);
      break;

    default:
      break;
  }
};

export const TripTypeOption = ({
  optionName,
  setOption,
  isActiveOption,
  style,
  title
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { trackTemplateEvent } = cabsLandingContext;
  return (
    <div
      className={`makeFlex ${style.tripOptionButton}`}
      onClick={() => {
        setOption(optionName);
        setOmniture(title, trackTemplateEvent);
      }}
      style={{
        marginRight: '5px',
        borderRadius: '4.5px',
        padding: '8px',
        border: isActiveOption
          ? '1px solid rgb(0, 140, 255)'
          : '1px solid rgb(231, 231, 231)',
        background: 'rgb(255, 255, 255)',
        boxShadow: !isActiveOption ? 'rgba(0, 0, 0, 0.4) 0px 1px 1px' : 'none'
      }}
    >
      <span
        className={`${
          isActiveOption ? style.smallActiveCircleOuter : style.smallCircleOuter
        } vertlCenter`}
      >
        <span
          className={`${
            isActiveOption
              ? style.smallActiveCircleInner
              : style.smallCircleInner
          }`}
        ></span>
      </span>
      <div
        className={`font12 lineHeight14 vertlCenter ${
          isActiveOption ? `latoBold deepskyBlueText` : `latoRegular blackText`
        }`}
      >
        {title}
      </div>
    </div>
  );
};
